<template>
  <div
    v-if="tags.length > 0"
    class="tag-list-component"
  >
    <p
      v-if="title"
      class="tag-list-title"
    >
      {{ title }}
    </p>
    <ul class="tag-list">
      <li
        v-for="tag in tags"
        :key="tag.id"
        class="tag-item"
      >
        <router-link :to="{name: 'library#index', query: { tags: tag.id } }">
          {{ tag.name }}
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  components: { },
  props: {
    tags: {
      type: Array,
      default: (() => []),
    },
    title: {
      type: String,
      default: 'Explore Related Content',
    },
  },
  computed: { },
  methods: { },
};
</script>

<style lang="scss" scoped>
.tag-list-component {
  background-color: #f8f8f8;
  border-radius: 8px;
  padding: rem-calc(16) rem-calc(24);

  .tag-list {
    padding: 0;
    list-style-type: none;

    .tag-item {
      font-size: rem-calc(14);
      font-weight: $semi-bold;
      color: #000000;
      display: inline-block;
      border-bottom: 2px solid #00dbfb;
      margin: rem-calc(8);

      a {
        text-decoration: none;
        color: inherit;
      }
    }
  }
}
</style>
